import { Component, OnInit, TemplateRef } from '@angular/core';
import { AgencyService } from './agency.service';
import { Agency } from './agency';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Department } from '../department/department';
import { DepartmentService } from '../department/department.service';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { LocalService } from '../../local.service';

declare var $: any;

@Component({
  selector: 'app-agency',
  templateUrl: './agency.component.html',
  styleUrls: ['./agency.component.css']
})
export class AgencyComponent implements OnInit {
  sendMenuId: number;
  sendPageName: string = 'Agency';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  agencyModalRef: BsModalRef;
  agencyForm: FormGroup; operationType: string; submitted = false; agency: Agency;
  active: number; agencyid: number;
  AgencyExist: boolean = false;
  departments: Department[]; p: number = 1; public searchText: string;
  itemsPerPage: number = 10;
  showall: boolean = true;
  showallstatus: boolean = false;
  key: string = 'agency'; //set default
  reverse: boolean = false;
  agencycies: Agency[] = [];
  agencyciesactive: Agency[] = [];

  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    ignoreBackdropClick: true,
    class: 'modal-dialog-centered'
  }

  constructor(
    private agencyService: AgencyService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private department: DepartmentService, private router: Router ,
    private dialogService: DialogService, private localService: LocalService) {
    //code to get relavent menu id      
   if (this.router.getCurrentNavigation().extras.state != undefined) {
      //console.log(this.router.getCurrentNavigation().extras.state);
      localStorage.setItem('Agency_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('Agency_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('Agency_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('Agency_action');
    } 
  }
 
 
  ngOnInit() {
    this.checkIsMenuMapped();  
    this.agencyForm = this.formBuilder.group({
      agencyid: [''],
      agency: ['', [Validators.required]],
      departmentid: ['', Validators.required],
      active: ['']
    })   
    this.getAll();
   
    this.GetAllDepartments();
    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }

  getAll() {
    this.agencycies = [];
    this.agencyciesactive = [];
    this.agencyService.Get().subscribe(res => {
      this.agencycies = res;
      if (this.showallstatus == true) {
        this.agencycies.forEach(data => {
          if (data.active == 1) {
            this.agencyciesactive.push(data);
          }
        });
        this.agencycies = [];
        this.agencycies = this.agencyciesactive;
      }
      //console.log(this.agencycies);
    }, error => { this.toastr.error('error while getting Agency Data') });
  }

  getactiveinactive(showallp) {
    this.agencyciesactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.agencycies.forEach(data => {
        if (data.active == 1) {
          this.agencyciesactive.push(data);
        }
      });
      this.agencycies = [];
      this.agencycies = this.agencyciesactive;
    }
    else {
      this.showall = true;
      this.agencycies = [];
      this.getAll();
    }
  }
 
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }
   
  get f() { return this.agencyForm.controls; }

  GetAllDepartments() {
    this.department.GetActive().subscribe(res => {
    this.departments = res;
      //console.log(this.departments)
    }, error => { this.toastr.error('Error while getting DepartmentData') })
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedagency");
    let data = arrays.find(ob => ob['name'] === 'Agency');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedagency","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedagency",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.agencyModalRef.hide();
  }

  validateAgency(event) {

    if (this.f.agency.valid) {
      this.agencyService.ValidateAgency(event.currentTarget.value).subscribe(result => {
        if (result) {
          this.agencyForm.controls['agency'].setErrors({ 'incorrect': true });
          this.AgencyExist = true;
        }
        else {
          this.agencyForm.controls['agency'].setErrors(null);
          this.AgencyExist = false;
        }

      }, error => {
        if (error.status == 400) {
        }
      });
    }

  }

  Postagency(agency: Agency) {

    this.submitted = true;
    if (this.agencyForm.value.departmentid == 0) {
      this.toastr.warning('Please select the department')
      return;
    }
    if ((agency.agency.trim() == undefined) || (agency.agency.trim() == '') ) {
      this.toastr.error('Agency should not be empty');
      return;
    }
    // stop here if form is invalid
    if (this.agencyForm.invalid) {

      this.toastr.warning('Entered values may be wrong');
      return;
    }

    //if (this.user.userid) {
    //  this.userid = this.user.userid

    //}
    var msg = null
    agency.agency = agency.agency.trim();
    if (this.operationType == 'addagency') {
      msg = "Agency Details Added Successfully";
      agency.agencyid = 0;
      agency.active = 1;
      //agency.createdby = +localStorage.getItem("userid");
      agency.createdby = +this.localService.getJsonValue("userid");
      this.agencyService.Post(agency).subscribe(res => { if (res.status == 200) {
        if (res != undefined) {
          if (res.body != 0) {
            this.agencyModalRef.hide();
            this.getAll();
            this.toastr.success('Data Added successfully');
          }
          else { this.toastr.warning('Record already exists.'); }
        }


      } },
        error => { this.toastr.error(error.message); })
    }
    else if (this.operationType = 'updateagency') {
      this.submitShow = true;
      //agency.modifiedby = +localStorage.getItem("userid");
      agency.modifiedby = +this.localService.getJsonValue("userid");
      agency.active = this.active;
      this.agencyService.Put(agency).subscribe(res => { if (res.status == 200) {
        if (res != undefined) {
          if (res.body != 0) {
            this.agencyModalRef.hide();
            this.getAll();
            this.toastr.success('Data Updated successfully');
          }
          else { this.toastr.warning('Record already exists.'); }
        }


      } },
        error => { this.toastr.error(error.message); })
     
    }

    //this.agencyForm.value.active = this.active;
    //this.agencyForm.value.agencyid = this.agencyid
    //console.log(this.agencyForm.value);
    

  }

  DeleteAgency(agency: Agency) {
    var msg;
    if (agency.active == 0) {
      agency.active = 1
      msg = "Agency activated successfully"
    }
    else {
      agency.active = 0;
      msg = "Agency deactivated successfully";
    }
    agency.agencyid = this.agency.agencyid;
    this.agencyService.Delete(agency).subscribe(res => { this.toastr.success(msg); this.ngOnInit(); }, error => { this.toastr.error("Getting error while deleting the Agency") })

  }

  ChangeActive(event) {
    if (event.currentTarget.checked) {
      this.active = 1;
    } else {
      this.active = 0
    }
  }

  OpenAgencyModal(template: TemplateRef<any>, type, agency?: Agency) {
    
   

    if (type == 'updateagency')
    {
    this.agencyForm.controls['agency'].setValue(agency.agency);
    this.agencyForm.controls['agencyid'].setValue(agency.agencyid);
    if (agency)
      this.agencyForm.controls['departmentid'].setValue(agency.departmentid);
    else
      this.agencyForm.controls['departmentid'].setValue(0);

    this.agencyForm.controls['active'].setValue(agency.active);
    //this.agencyForm.setValue({ 'agency': agency.agency, 'departmentid': agency.departmentid})  
    this.agency = agency
    }
    if (type == 'addagency') {
      this.agencyForm.controls['agency'].setValue('');
        
        this.agencyForm.controls['departmentid'].setValue(0);
      this.agencyForm.controls['active'].setValue(0);
      //this.agencyForm.setValue({ 'agency': agency.agency, 'departmentid': agency.departmentid})  
      this.agency = agency
    }


    this.operationType = type;
    this.agencyModalRef = this.modalService.show(template, this.config)
    
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");
    //this.agencyid = this.agency.agencyid; this.active = this.agency.active;
  }

  OpenConfirmTemplate(agency: Agency, template: TemplateRef<any>) {
    //this.agencyModalRef = this.modalService.show(template);
    this.agency = agency;
    var confmsg;
    this.agencyid = agency.agencyid;
    if (agency.active == 0) {
      confmsg = "activate";
    }
    else
      confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {

          //this.userModalRef.hide();
          this.DeleteAgency(agency);
        }
        
      });
  }

}
